import IconWithRichText from './IconWithRichText';

export default IconWithRichText;
